import React, { useState, useEffect } from 'react';
import Dropdown from '../../../../Components/Dropdown';
import Listbox from '../../../../Components/Listbox';
import ListboxItem from '../../../../Components/ListboxItem';
import Modal from '../../../../Components/Modal';
import IconBtn from '../../../../Components/IconBtn';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';
import ReplacementList from '../ManualSorting/ReplacementList';
import ShopifyManualSortingProductPositionSelector from '../ManualSorting/ShopifySorting/ShopifyManualSortingProductPositionSelector';
import { PinnedShopifyProduct } from '../ManualSorting/ShopifySorting/ShopifyManualSortingTypes';

export default function ProductItemDropDown({
	idProduct,
	idInClipBoard,
	isATransformationReplace,
	isPinned,
	product
}) {
	const {
		addPromotedProductWithId,
		addDemotedProductWithId,
		addReplaceProductWithId,
		selectedCategoryIsShopifyCollection,
		shopifyCollections,
		shopifyCollectionWithPinnedProducts,
		shopifyCollectionPinnedProductsService,
		typeCategoriesSecondLevelSelected,
		searchProducts
	} = useRankingContext();
	const [editDropdownIsOpen, setEditDropdownIsOpen] = useState(false);
	const [replacementListModalIsOpen, setReplacementListModalIsOpen] = useState(false);
	const [pinModalIsOpen, setPinModalIsOpen] = useState<{
		show: boolean,
		edit?: { collectionId: string, product: PinnedShopifyProduct }
	}>({ show: false });
	const [valueOfSelection, setvalueOfSelection] = useState({
		toReplaceId: idProduct,
		replaceId: idInClipBoard
	});
	const [modalHeight, setModalHeight] = useState(640);

	function openModalWithIdOfProduct() {
		setEditDropdownIsOpen(false);
		setReplacementListModalIsOpen(true);
	}
	function handleChangeValueOfSelection(newVal) {
		setvalueOfSelection(newVal);
	}
	function addNewReplaceTranformation() {
		addReplaceProductWithId(valueOfSelection);
		setReplacementListModalIsOpen(false);
	}
	useEffect(() => {
		setvalueOfSelection({
			toReplaceId: idProduct,
			replaceId: idInClipBoard
		});
	}, [idInClipBoard]);

	const productSelector = () =>
		<ShopifyManualSortingProductPositionSelector
			showPopin={pinModalIsOpen}
			handleClose={() => setPinModalIsOpen({ show: false })}
			shopifyCollections={shopifyCollections || []}
			collectionWithPinnedProducts={shopifyCollectionWithPinnedProducts ?? []}
			handleConfirm={shopifyCollectionPinnedProductsService.handleAddProductPosition}
			searchProducts={searchProducts}
			typeCategoriesSecondLevelSelected={typeCategoriesSecondLevelSelected}
			selectedCategoryIsShopifyCollection={selectedCategoryIsShopifyCollection}
		/>;

	return (<>
		{replacementListModalIsOpen &&
			<Modal
				isOpen={replacementListModalIsOpen}
				width={450}
				height={modalHeight}
				onClose={() => setReplacementListModalIsOpen(false)}
			>
				<ReplacementList
					valueOfSelection={valueOfSelection}
					addReplaceManualy={handleChangeValueOfSelection}
					isLocked={true}
					fromProduct={true}
					onAdd={addNewReplaceTranformation}
					setModalHeight={setModalHeight}
				/>
			</Modal>
		}
		{pinModalIsOpen &&
			productSelector()
		}
		<Dropdown
			isOpen={editDropdownIsOpen}
			setIsOpen={() => setEditDropdownIsOpen(true)}
			onHide={() => setEditDropdownIsOpen(false)}
			button={
				<IconBtn
					icon="fas fa-ellipsis-v"
				/>
			}
		>
			<Listbox>
				{selectedCategoryIsShopifyCollection.isPinnableShopifyCollection &&
					<ListboxItem
						message="Pin"
						icon="fas fa-thumbtack"
						onClick={() => {
							setEditDropdownIsOpen(false);
							setPinModalIsOpen({
								show: true, edit: {
									product: { product, position: !isPinned.pinned ? 0 : isPinned.productWithPosition.position },
									collectionId: selectedCategoryIsShopifyCollection.collectionId ?? ''
								}
							});
						}}
						disabled={isATransformationReplace}
					/>
				}
				{!selectedCategoryIsShopifyCollection.isPinnableShopifyCollection &&
					<ListboxItem
						message="Promote"
						icon="fas fa-arrow-circle-up"
						onClick={() => {
							addPromotedProductWithId(idProduct);
							setEditDropdownIsOpen(false);
						}}
						disabled={isATransformationReplace || (selectedCategoryIsShopifyCollection.isPinnableShopifyCollection && isPinned.pinned)}
					/>
				}
				<ListboxItem
					message="Demote"
					icon="fas fa-arrow-circle-down"
					onClick={() => {
						addDemotedProductWithId(idProduct);
						setEditDropdownIsOpen(false);
					}}
					disabled={isATransformationReplace || (selectedCategoryIsShopifyCollection.isPinnableShopifyCollection && isPinned.pinned)}
				/>

				<ListboxItem
					message="Swap"
					icon="fas fa-retweet"
					onClick={() => openModalWithIdOfProduct()}
					disabled={isPinned.pinned}
				/>
			</Listbox>
		</Dropdown>
	</>
	);
}
